var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesk6PersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 556.534,
    height: 348.116,
    viewBox: "0 0 556.534 348.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desk_6_person-icon",
    "data-name": "desk 6 person-icon",
    transform: "translate(1112.883 1482.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(949.767 66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-6516.883 2693.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M5010.767-3950.339H4971.8c-.147-.906-.285-1.755-.457-2.816h36.312v-108.8H4832.071v108.662h36.317c-.139,1.072-.249,1.927-.382,2.951H4829V-4065h181.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M5015.576-3609.57c-3.546-.591-7.124-1.033-10.63-1.8a49.336,49.336,0,0,1-18.082-7.862c-1.842-1.3-2.261-2.626-1.284-3.97.911-1.253,2.356-1.3,4.065-.137,10.8,7.364,22.909,9.417,35.669,8.617a52.121,52.121,0,0,0,21.564-5.839c1.715-.916,3.317-2.043,4.971-3.074,1.4-.871,2.8-.708,3.634.422.9,1.216.62,2.624-.826,3.67a51.024,51.024,0,0,1-20.067,8.536c-3,.608-6.049.968-9.075,1.441Z",
    transform: "translate(-100.663 -284.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M4967.435-3817.687l4.166-2.464c-2.874,17.942,11.043,30.634,25.33,30.423,14-.207,27.424-12.687,24.6-30.468l4.224,2.532c1.055-2.623,2.145-5.154,3.059-7.748.2-.565-.17-1.372-.383-2.035-3.531-11.022-7.113-22.028-10.607-33.062a7.915,7.915,0,0,1,6.563-10.492,7.8,7.8,0,0,1,8.362,5.218c4.15,12.684,8.252,25.384,12.2,38.131a8.486,8.486,0,0,1-.188,5.177c-3.566,9.256-7.233,18.479-11.121,27.6-2.485,5.833-7.354,9.467-12.856,12.214-10.282,5.131-21.209,6.288-32.473,4.815a45.745,45.745,0,0,1-20.285-7.391,24.655,24.655,0,0,1-9.469-11.835c-3.087-8.112-6.43-16.128-9.753-24.147a10.6,10.6,0,0,1-.285-7.744c3.989-12.177,7.857-24.394,11.825-36.578a7.786,7.786,0,0,1,7.65-5.5,7.5,7.5,0,0,1,7.344,5.6,11.659,11.659,0,0,1-.269,5.7c-3.309,10.72-6.777,21.391-10.282,32.049a5.134,5.134,0,0,0,.188,4.054C4965.859-3821.717,4966.6-3819.737,4967.435-3817.687Z",
    transform: "translate(-76.704 -125.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M5022.026-3753.955a22.326,22.326,0,0,1,22.393-22.271,22.322,22.322,0,0,1,22.312,22.355,22.447,22.447,0,0,1-22.4,22.327A22.44,22.44,0,0,1,5022.026-3753.955Z",
    transform: "translate(-124.499 -186.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M5003.151-3747.271c.116-2.8.25-2.934,2.708-2.931q2.028,0,4.057.036c.09,0,.178.118.266.183-.978,2.712-.978,2.712-3.747,2.712Z",
    transform: "translate(-112.325 -203.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M5154.007-3747.269c-2.291,0-3.992.262-5.548-.1-.889-.208-1.54-1.435-2.3-2.2l.247-.571a44.882,44.882,0,0,1,6.148.114C5153.076-3749.958,5153.4-3748.483,5154.007-3747.269Z",
    transform: "translate(-204.565 -203.046)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1687.883 -1548.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M4829-4065h38.963c.147.906.285,1.755.457,2.816h-36.312v108.8H5007.7v-108.662h-36.317c.139-1.072.249-1.927.382-2.951h39.007v114.661H4829Z",
    transform: "translate(-4829 4121.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M5025.492-3624.2c3.546.591,7.124,1.033,10.63,1.8a49.336,49.336,0,0,1,18.082,7.862c1.842,1.3,2.261,2.626,1.284,3.97-.911,1.253-2.356,1.3-4.065.137-10.8-7.364-22.909-9.417-35.669-8.617a52.121,52.121,0,0,0-21.564,5.839c-1.715.916-3.317,2.043-4.971,3.074-1.4.871-2.8.708-3.634-.422-.9-1.216-.62-2.624.826-3.67a51.024,51.024,0,0,1,20.067-8.536c3-.608,6.049-.968,9.075-1.441Z",
    transform: "translate(-4929.639 3624.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M5025.756-3830.624l-4.166,2.464c2.874-17.942-11.043-30.634-25.33-30.423-14,.207-27.424,12.688-24.6,30.468l-4.224-2.532c-1.055,2.623-2.145,5.154-3.059,7.748-.2.565.17,1.372.383,2.035,3.531,11.022,7.113,22.028,10.607,33.062a7.915,7.915,0,0,1-6.563,10.492,7.8,7.8,0,0,1-8.362-5.218c-4.15-12.684-8.252-25.384-12.2-38.131a8.486,8.486,0,0,1,.188-5.177c3.566-9.256,7.233-18.479,11.121-27.6,2.485-5.833,7.354-9.467,12.856-12.214,10.282-5.131,21.209-6.288,32.473-4.815a45.745,45.745,0,0,1,20.285,7.391,24.655,24.655,0,0,1,9.469,11.835c3.087,8.112,6.43,16.128,9.753,24.147a10.6,10.6,0,0,1,.285,7.744c-3.989,12.177-7.857,24.394-11.825,36.578a7.786,7.786,0,0,1-7.65,5.5,7.5,7.5,0,0,1-7.344-5.6,11.659,11.659,0,0,1,.269-5.7c3.309-10.72,6.777-21.391,10.282-32.049a5.134,5.134,0,0,0-.188-4.054C5027.333-3826.594,5026.6-3828.573,5025.756-3830.624Z",
    transform: "translate(-4905.72 3879.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M5066.731-3753.814a22.326,22.326,0,0,1-22.393,22.271,22.322,22.322,0,0,1-22.312-22.355,22.447,22.447,0,0,1,22.4-22.327A22.44,22.44,0,0,1,5066.731-3753.814Z",
    transform: "translate(-4953.491 3800.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M5010.181-3750.2c-.116,2.8-.25,2.934-2.708,2.931q-2.028,0-4.057-.036c-.09,0-.178-.118-.266-.183.978-2.712.978-2.712,3.747-2.712Z",
    transform: "translate(-4890.24 3806.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M5146.161-3750.1c2.291,0,3.992-.262,5.548.1.889.208,1.54,1.435,2.3,2.2l-.247.571a44.882,44.882,0,0,1-6.148-.114C5147.092-3747.413,5146.767-3748.888,5146.161-3750.1Z",
    transform: "translate(-5084.836 3806.533)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(176 66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(-6516.883 2693.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M5010.767-3950.339H4971.8c-.147-.906-.285-1.755-.457-2.816h36.312v-108.8H4832.071v108.662h36.317c-.139,1.072-.249,1.927-.382,2.951H4829V-4065h181.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2",
    d: "M5015.576-3609.57c-3.546-.591-7.124-1.033-10.63-1.8a49.336,49.336,0,0,1-18.082-7.862c-1.842-1.3-2.261-2.626-1.284-3.97.911-1.253,2.356-1.3,4.065-.137,10.8,7.364,22.909,9.417,35.669,8.617a52.121,52.121,0,0,0,21.564-5.839c1.715-.916,3.317-2.043,4.971-3.074,1.4-.871,2.8-.708,3.634.422.9,1.216.62,2.624-.826,3.67a51.024,51.024,0,0,1-20.067,8.536c-3,.608-6.049.968-9.075,1.441Z",
    transform: "translate(-100.663 -284.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-3",
    "data-name": "Path 3",
    d: "M4967.435-3817.687l4.166-2.464c-2.874,17.942,11.043,30.634,25.33,30.423,14-.207,27.424-12.687,24.6-30.468l4.224,2.532c1.055-2.623,2.145-5.154,3.059-7.748.2-.565-.17-1.372-.383-2.035-3.531-11.022-7.113-22.028-10.607-33.062a7.915,7.915,0,0,1,6.563-10.492,7.8,7.8,0,0,1,8.362,5.218c4.15,12.684,8.252,25.384,12.2,38.131a8.486,8.486,0,0,1-.188,5.177c-3.566,9.256-7.233,18.479-11.121,27.6-2.485,5.833-7.354,9.467-12.856,12.214-10.282,5.131-21.209,6.288-32.473,4.815a45.745,45.745,0,0,1-20.285-7.391,24.655,24.655,0,0,1-9.469-11.835c-3.087-8.112-6.43-16.128-9.753-24.147a10.6,10.6,0,0,1-.285-7.744c3.989-12.177,7.857-24.394,11.825-36.578a7.786,7.786,0,0,1,7.65-5.5,7.5,7.5,0,0,1,7.344,5.6,11.659,11.659,0,0,1-.269,5.7c-3.309,10.72-6.777,21.391-10.282,32.049a5.134,5.134,0,0,0,.188,4.054C4965.859-3821.717,4966.6-3819.737,4967.435-3817.687Z",
    transform: "translate(-76.704 -125.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-3",
    "data-name": "Path 4",
    d: "M5022.026-3753.955a22.326,22.326,0,0,1,22.393-22.271,22.322,22.322,0,0,1,22.312,22.355,22.447,22.447,0,0,1-22.4,22.327A22.44,22.44,0,0,1,5022.026-3753.955Z",
    transform: "translate(-124.499 -186.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-3",
    "data-name": "Path 5",
    d: "M5003.151-3747.271c.116-2.8.25-2.934,2.708-2.931q2.028,0,4.057.036c.09,0,.178.118.266.183-.978,2.712-.978,2.712-3.747,2.712Z",
    transform: "translate(-112.325 -203.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-3",
    "data-name": "Path 6",
    d: "M5154.007-3747.269c-2.291,0-3.992.262-5.548-.1-.889-.208-1.54-1.435-2.3-2.2l.247-.571a44.882,44.882,0,0,1,6.148.114C5153.076-3749.958,5153.4-3748.483,5154.007-3747.269Z",
    transform: "translate(-204.565 -203.046)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    transform: "translate(-1687.883 -1548.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-4",
    "data-name": "Path 1",
    d: "M4829-4065h38.963c.147.906.285,1.755.457,2.816h-36.312v108.8H5007.7v-108.662h-36.317c.139-1.072.249-1.927.382-2.951h39.007v114.661H4829Z",
    transform: "translate(-4829 4121.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-4",
    "data-name": "Path 2",
    d: "M5025.492-3624.2c3.546.591,7.124,1.033,10.63,1.8a49.336,49.336,0,0,1,18.082,7.862c1.842,1.3,2.261,2.626,1.284,3.97-.911,1.253-2.356,1.3-4.065.137-10.8-7.364-22.909-9.417-35.669-8.617a52.121,52.121,0,0,0-21.564,5.839c-1.715.916-3.317,2.043-4.971,3.074-1.4.871-2.8.708-3.634-.422-.9-1.216-.62-2.624.826-3.67a51.024,51.024,0,0,1,20.067-8.536c3-.608,6.049-.968,9.075-1.441Z",
    transform: "translate(-4929.639 3624.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-4",
    "data-name": "Path 3",
    d: "M5025.756-3830.624l-4.166,2.464c2.874-17.942-11.043-30.634-25.33-30.423-14,.207-27.424,12.688-24.6,30.468l-4.224-2.532c-1.055,2.623-2.145,5.154-3.059,7.748-.2.565.17,1.372.383,2.035,3.531,11.022,7.113,22.028,10.607,33.062a7.915,7.915,0,0,1-6.563,10.492,7.8,7.8,0,0,1-8.362-5.218c-4.15-12.684-8.252-25.384-12.2-38.131a8.486,8.486,0,0,1,.188-5.177c3.566-9.256,7.233-18.479,11.121-27.6,2.485-5.833,7.354-9.467,12.856-12.214,10.282-5.131,21.209-6.288,32.473-4.815a45.745,45.745,0,0,1,20.285,7.391,24.655,24.655,0,0,1,9.469,11.835c3.087,8.112,6.43,16.128,9.753,24.147a10.6,10.6,0,0,1,.285,7.744c-3.989,12.177-7.857,24.394-11.825,36.578a7.786,7.786,0,0,1-7.65,5.5,7.5,7.5,0,0,1-7.344-5.6,11.659,11.659,0,0,1,.269-5.7c3.309-10.72,6.777-21.391,10.282-32.049a5.134,5.134,0,0,0-.188-4.054C5027.333-3826.594,5026.6-3828.573,5025.756-3830.624Z",
    transform: "translate(-4905.72 3879.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-4",
    "data-name": "Path 4",
    d: "M5066.731-3753.814a22.326,22.326,0,0,1-22.393,22.271,22.322,22.322,0,0,1-22.312-22.355,22.447,22.447,0,0,1,22.4-22.327A22.44,22.44,0,0,1,5066.731-3753.814Z",
    transform: "translate(-4953.491 3800.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-4",
    "data-name": "Path 5",
    d: "M5010.181-3750.2c-.116,2.8-.25,2.934-2.708,2.931q-2.028,0-4.057-.036c-.09,0-.178-.118-.266-.183.978-2.712.978-2.712,3.747-2.712Z",
    transform: "translate(-4890.24 3806.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-4",
    "data-name": "Path 6",
    d: "M5146.161-3750.1c2.291,0,3.992-.262,5.548.1.889.208,1.54,1.435,2.3,2.2l-.247.571a44.882,44.882,0,0,1-6.148-.114C5147.092-3747.413,5146.767-3748.888,5146.161-3750.1Z",
    transform: "translate(-5084.836 3806.533)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(364 66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2-3",
    "data-name": "Group 2",
    transform: "translate(-6516.883 2693.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-5",
    "data-name": "Path 1",
    d: "M5010.767-3950.339H4971.8c-.147-.906-.285-1.755-.457-2.816h36.312v-108.8H4832.071v108.662h36.317c-.139,1.072-.249,1.927-.382,2.951H4829V-4065h181.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-5",
    "data-name": "Path 2",
    d: "M5015.576-3609.57c-3.546-.591-7.124-1.033-10.63-1.8a49.336,49.336,0,0,1-18.082-7.862c-1.842-1.3-2.261-2.626-1.284-3.97.911-1.253,2.356-1.3,4.065-.137,10.8,7.364,22.909,9.417,35.669,8.617a52.121,52.121,0,0,0,21.564-5.839c1.715-.916,3.317-2.043,4.971-3.074,1.4-.871,2.8-.708,3.634.422.9,1.216.62,2.624-.826,3.67a51.024,51.024,0,0,1-20.067,8.536c-3,.608-6.049.968-9.075,1.441Z",
    transform: "translate(-100.663 -284.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-5",
    "data-name": "Path 3",
    d: "M4967.435-3817.687l4.166-2.464c-2.874,17.942,11.043,30.634,25.33,30.423,14-.207,27.424-12.687,24.6-30.468l4.224,2.532c1.055-2.623,2.145-5.154,3.059-7.748.2-.565-.17-1.372-.383-2.035-3.531-11.022-7.113-22.028-10.607-33.062a7.915,7.915,0,0,1,6.563-10.492,7.8,7.8,0,0,1,8.362,5.218c4.15,12.684,8.252,25.384,12.2,38.131a8.486,8.486,0,0,1-.188,5.177c-3.566,9.256-7.233,18.479-11.121,27.6-2.485,5.833-7.354,9.467-12.856,12.214-10.282,5.131-21.209,6.288-32.473,4.815a45.745,45.745,0,0,1-20.285-7.391,24.655,24.655,0,0,1-9.469-11.835c-3.087-8.112-6.43-16.128-9.753-24.147a10.6,10.6,0,0,1-.285-7.744c3.989-12.177,7.857-24.394,11.825-36.578a7.786,7.786,0,0,1,7.65-5.5,7.5,7.5,0,0,1,7.344,5.6,11.659,11.659,0,0,1-.269,5.7c-3.309,10.72-6.777,21.391-10.282,32.049a5.134,5.134,0,0,0,.188,4.054C4965.859-3821.717,4966.6-3819.737,4967.435-3817.687Z",
    transform: "translate(-76.704 -125.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-5",
    "data-name": "Path 4",
    d: "M5022.026-3753.955a22.326,22.326,0,0,1,22.393-22.271,22.322,22.322,0,0,1,22.312,22.355,22.447,22.447,0,0,1-22.4,22.327A22.44,22.44,0,0,1,5022.026-3753.955Z",
    transform: "translate(-124.499 -186.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-5",
    "data-name": "Path 5",
    d: "M5003.151-3747.271c.116-2.8.25-2.934,2.708-2.931q2.028,0,4.057.036c.09,0,.178.118.266.183-.978,2.712-.978,2.712-3.747,2.712Z",
    transform: "translate(-112.325 -203.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-5",
    "data-name": "Path 6",
    d: "M5154.007-3747.269c-2.291,0-3.992.262-5.548-.1-.889-.208-1.54-1.435-2.3-2.2l.247-.571a44.882,44.882,0,0,1,6.148.114C5153.076-3749.958,5153.4-3748.483,5154.007-3747.269Z",
    transform: "translate(-204.565 -203.046)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-3",
    "data-name": "Group 3",
    transform: "translate(-1687.883 -1548.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-6",
    "data-name": "Path 1",
    d: "M4829-4065h38.963c.147.906.285,1.755.457,2.816h-36.312v108.8H5007.7v-108.662h-36.317c.139-1.072.249-1.927.382-2.951h39.007v114.661H4829Z",
    transform: "translate(-4829 4121.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-6",
    "data-name": "Path 2",
    d: "M5025.492-3624.2c3.546.591,7.124,1.033,10.63,1.8a49.336,49.336,0,0,1,18.082,7.862c1.842,1.3,2.261,2.626,1.284,3.97-.911,1.253-2.356,1.3-4.065.137-10.8-7.364-22.909-9.417-35.669-8.617a52.121,52.121,0,0,0-21.564,5.839c-1.715.916-3.317,2.043-4.971,3.074-1.4.871-2.8.708-3.634-.422-.9-1.216-.62-2.624.826-3.67a51.024,51.024,0,0,1,20.067-8.536c3-.608,6.049-.968,9.075-1.441Z",
    transform: "translate(-4929.639 3624.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-6",
    "data-name": "Path 3",
    d: "M5025.756-3830.624l-4.166,2.464c2.874-17.942-11.043-30.634-25.33-30.423-14,.207-27.424,12.688-24.6,30.468l-4.224-2.532c-1.055,2.623-2.145,5.154-3.059,7.748-.2.565.17,1.372.383,2.035,3.531,11.022,7.113,22.028,10.607,33.062a7.915,7.915,0,0,1-6.563,10.492,7.8,7.8,0,0,1-8.362-5.218c-4.15-12.684-8.252-25.384-12.2-38.131a8.486,8.486,0,0,1,.188-5.177c3.566-9.256,7.233-18.479,11.121-27.6,2.485-5.833,7.354-9.467,12.856-12.214,10.282-5.131,21.209-6.288,32.473-4.815a45.745,45.745,0,0,1,20.285,7.391,24.655,24.655,0,0,1,9.469,11.835c3.087,8.112,6.43,16.128,9.753,24.147a10.6,10.6,0,0,1,.285,7.744c-3.989,12.177-7.857,24.394-11.825,36.578a7.786,7.786,0,0,1-7.65,5.5,7.5,7.5,0,0,1-7.344-5.6,11.659,11.659,0,0,1,.269-5.7c3.309-10.72,6.777-21.391,10.282-32.049a5.134,5.134,0,0,0-.188-4.054C5027.333-3826.594,5026.6-3828.573,5025.756-3830.624Z",
    transform: "translate(-4905.72 3879.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-6",
    "data-name": "Path 4",
    d: "M5066.731-3753.814a22.326,22.326,0,0,1-22.393,22.271,22.322,22.322,0,0,1-22.312-22.355,22.447,22.447,0,0,1,22.4-22.327A22.44,22.44,0,0,1,5066.731-3753.814Z",
    transform: "translate(-4953.491 3800.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-6",
    "data-name": "Path 5",
    d: "M5010.181-3750.2c-.116,2.8-.25,2.934-2.708,2.931q-2.028,0-4.057-.036c-.09,0-.178-.118-.266-.183.978-2.712.978-2.712,3.747-2.712Z",
    transform: "translate(-4890.24 3806.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-6",
    "data-name": "Path 6",
    d: "M5146.161-3750.1c2.291,0,3.992-.262,5.548.1.889.208,1.54,1.435,2.3,2.2l-.247.571a44.882,44.882,0,0,1-6.148-.114C5147.092-3747.413,5146.767-3748.888,5146.161-3750.1Z",
    transform: "translate(-5084.836 3806.533)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk6PersonIcon);
export default __webpack_public_path__ + "static/media/desk 6 person-icon.2f2ae25a413066aef23dac429c282005.svg";
export { ForwardRef as ReactComponent };